exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".viewstrap .vp-credit-card-icon{width:32px;height:32px;display:inline-block;background-position:50%}.vp-credit-card-icon.jcb,.vp-credit-card-icon.unknown{display:none}", ""]);

// exports
